import React from 'react';
import './GuestHome.css';
import '../LandingI18n/i18n'; 
import GuestHeroSection from './GuestHeroSection';
import DashboardSection from './DashboardSection';
import FeaturesSection from './FeaturesSection';
// import TabbedSection from './TabbedSection';
// import TestimonialSlider from './TestimonialSlider';
import CLMCards from './CLMCards';
import CTASection from './CTASection';
import ContractLifecycle from './ContractLifecycle';
import ElectronicSignatureHome from './ElectronicSignatureHome';

const GuestHome = () => {
  return (
    <div className="landing-page">
      <GuestHeroSection />
      <DashboardSection />
      <FeaturesSection />
      <ContractLifecycle />
      {/* <TabbedSection /> */}
      {/* <TestimonialSlider /> */}
      <CLMCards />
      <CTASection />
      <ElectronicSignatureHome />
    </div>
  );
};

export default GuestHome;
